import React from 'react';
import { useImageUrlCheck } from 'src/hooks/useImageUrlCheck';
import { PreloadImage } from 'src/features/common/app/components/preload-image';
import { useDevicePixelRatio } from 'src/hooks/use-device-pixel-ratio';
import { VideoInnerWrapper, StyledImage, StyledRatio } from './profile-banner.styles';

interface IProps {
    url?: string;
    retinaUrl?: string;
    videoUrl?: string;
    retinaVideoUrl?: string;
}

export const ProfileBanner: React.VFC<IProps> = ({ url, retinaVideoUrl, videoUrl, retinaUrl }) => {
    const devicePixelRatio = useDevicePixelRatio();
    const image = useImageUrlCheck({ imageUrl: url, skip: !!videoUrl });
    const retinaImage = useImageUrlCheck({ imageUrl: retinaUrl, skip: !!videoUrl });

    const srcSet = (image && retinaImage) ? `${image} 1x, ${retinaImage} 2x` : undefined;

    const video = devicePixelRatio > 1 ? retinaVideoUrl : videoUrl;

    return (
        <>
            {image && <PreloadImage src={image} />}
            <StyledImage>
                <StyledRatio />
                {image && <img src={image} srcSet={srcSet} alt='profile banner' />}
                {video && (
                    <VideoInnerWrapper>
                        <video
                            muted
                            autoPlay
                            src={video}
                            playsInline
                            loop
                            controls={false}
                            controlsList='nodownload'
                        >
                            <source src={video} type="video/mp4" />
                            <track kind='captions' srcLang='en' label='english_captions' />
                        </video>
                    </VideoInnerWrapper>
                )}
            </StyledImage>
        </>
    );
};
